import { useQuery } from "@tanstack/react-query";
import { qk } from "../../lib/queryKeys";
import { getJson } from "../../lib/http";
import { useCompaniesStore } from "../../store/admin/companiesStore";
import type { Aviso } from "../../store/admin/avisosStore";

export interface AvisoListParams {
  page?: number;
  limit?: number;
  status?: string;
  scope?: string;
  search?: string;
}

interface ListMeta {
  error: string | null;
  count: number;
  status: number;
  currentPage: number;
  totalPages: number;
  totalItems: number;
  url: string;
}

interface AvisoListBody {
  data?: Aviso[];
  meta?: ListMeta;
}

export interface AvisoListResult {
  data: Aviso[];
  meta?: ListMeta;
}

export function useAvisosList(params: AvisoListParams = {}) {
  const companyId = useCompaniesStore((s) => s.companyId);
  return useQuery({
    queryKey: qk.avisos.list(companyId, params),
    queryFn: ({ signal }) =>
      getJson<AvisoListBody>(
        "/avisosList",
        { page: 1, limit: 12, ...params },
        { signal },
      ).then((body) => ({ data: body.data ?? [], meta: body.meta })),
  });
}
